export const styledAvatarTypes = ['Client', 'SMS', 'TestClient', 'Automated', 'Clinic'] as const;

export type StyledAvatarType = (typeof styledAvatarTypes)[number];
